// extracted by mini-css-extract-plugin
export default {"container":"pHmHX1tlLf9GsUuENVdH","containerCompact":"Z9uIqyZqz1Prok8zBhR8","icon":"lxi0Skt21k5uI9N7OM0M","text":"bo_77sA3WanW02YD8TtX","link":"dnuSqVw01ZqgWEJhZ27a"};